module.exports = __webpack_public_path__ + "static/8-cc27c92d571efc63e32e4ceea8691ff2.png";